define('static/js/request', function(require, exports, module) {

  var $ = require("static/js/jquery");
  var cookieJS = require("static/js/cookie");
  var Fingerprint2 = require("static/js/fingerprint2.min");
  var cookie = cookieJS.cookie;
  // var objKeySort = require("./objKeySort")
  // require("./objKeySort")
  var indexJS = require("static/js/device_index");
  indexJS.deviceObj.init();
  // var device=require('./ua/ua-device.js');
  
  // index()
  function deobfuscateString(obfuscated) {
    var result = "";
    for (var i = 0; i < obfuscated.length; i += 2) {
      var hexChar = obfuscated.substr(i, 2);
      var charCode = parseInt(hexChar, 16);
      result += String.fromCharCode(charCode);
    }
    return result;
  }
  
  function objKeySort(obj) {
    // 排序的函数
    var newkey = Object.keys(obj).sort();
    // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newObj = {}; // 创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {
      // 遍历newkey数组
      newObj[newkey[i]] = obj[newkey[i]]; // 向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj; // 返回排好序的新对象
  }
  // require('../plugins/ua/useragent-base.js');
  
  // var helpConfigJS = require('./helpConfig');
  // Generate four random hex digits.
  // function S4() {
  //     return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  //  };
  // Generate a pseudo-GUID by concatenating random hexadecimal.
  //  90dea20e-4a43-3fdf-bf3c-7f3d5bc4231a
  //  function guid() {
  //     return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
  
  //  }
  //  alert(guid())
  // function start() {
  //     const start = new Date().getTime();
  //     let view = document.querySelector('#help-onlineBox');
  //     view.innerHTML = '';
  //     let excludes = {};
  //     excludes.userAgent = true;
  //     excludes.audio = true;
  //     excludes.enumerateDevices = true;
  //     excludes.fonts = true;
  //     excludes.fontsFlash = true;
  //     excludes.webgl = true;
  //     excludes.canvas = true;
  //     let options = {excludes: excludes}
  
  //     new Fingerprint2().get(function(result, components) {
  //         // 参数000000000000000000
  //         console.log(components)
  //         const values = components.map(function (component) {
  //             return component.value
  //         });
  //         console.log(values)
  
  //     });
  // }
  // setTimeout(function(){
  //     start()
  // },1000)
  // var http_build_query = require('./http_build_query')
  // require('jQuery.md5.js')
  // var CryptoJS = require("./crypto-js")
  
  // var proxy = require("./proxy.js")
  // var appKey =proxy.proxyObj.appKey
  //写cookies
  // function objKeySort(obj, sort_flags) {
  //     var newkey = Object.keys(obj).sort();
  //     　　//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  //         var newObj = {};//创建一个新的对象，用于存放排好序的键值对
  //         for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
  //             newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
  //         }
  //         return newObj;//返回排好序的新对象
  //   }
  // console.log(ngerprint2,'ngerprint2ngerprint2')
  // setTimeout(function () {
  //     // new ngerprint2().get(function(result, components) {
  //     new ngerprint2().get(function (components) {
  //          // console.log(components) // an array of components: {key: ..., value: ...}
  //          var values = components.map(function (component) { return component.value })
  //          var murmur = Fingerprint2.x64hash128(values.join(''), 31)
  //          console.log(murmur);//在这里就是打印的浏览器指纹
  
  //        })
  //    }, 500)
  
  function setCookie(name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  }
  
  //读取cookies
  function getCookie(name) {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  
    if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
    else return null;
  }
  
  //DES 解密 加密
  function encryptByDES(message, key) {
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Zero,
    });
    return encrypted.toString();
  }
  //DES 解密
  function decryptByDES(ciphertext, key) {
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    // direct decrypt ciphertext
    var decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(ciphertext),
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        //这一步 是来填写 加密时候填充方式
        padding: CryptoJS.pad.Pkcs7,
      }
    );
  
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  
  function validataOS() {
    if (navigator.userAgent.indexOf("Window") > 0) {
      return 5;
    } else if (navigator.userAgent.indexOf("Mac OS X") > 0) {
      return 4;
    } else if (navigator.userAgent.indexOf("Linux") > 0) {
      return 6;
    } else {
      return "";
    }
  }
  // var osData = [
  //     { name: 'Windows 2000', group: 'windows_server', identifier: 'Windows NT 5.0', version: '5.0' },
  //     { name: 'Windows XP', group: 'windows', identifier: 'Windows NT 5.1', version: '5.1' },
  //     { name: 'Windows 2003', group: 'windows_server', identifier: 'Windows NT 5.2', version: '5.2' },
  //     { name: 'Windows Vista', group: 'windows', identifier: 'Windows NT 6.0', version: '6.0' },
  //     { name: 'Windows 7', group: 'windows', identifier: 'Windows NT 6.1', version: '7.0' },
  //     { name: 'Windows 8', group: 'windows', identifier: 'Windows NT 6.2', version: '8.0' },
  //     { name: 'Windows 8.1', group: 'windows', identifier: 'Windows NT 6.3', version: '8.1' },
  //     { name: 'Windows 10', group: 'windows', identifier: 'Windows NT 10.0', version: '10.0' },
  //     { name: 'Windows 2008', group: 'windows_server', identifier: 'Windows NT 6.0; WOW64', version: '6.0' },
  //     { name: 'Windows 2008', group: 'windows_server', identifier: 'Windows NT 6.1; WOW64', version: '6.1' },
  //     { name: 'Windows 2012', group: 'windows_server', identifier: 'Windows NT 6.3; Win64', version: '6.3' },
  //     { name: 'Chrome OS', group: 'windows', identifier: 'CrOS' },
  //     { name: 'Mac OS X Capitan', group: 'mac', identifier: 'Mac OS X (10([_|\.])11([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Yosemite', group: 'mac', identifier: 'Mac OS X (10([_|\.])10([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Mavericks', group: 'mac', identifier: 'Mac OS X (10([_|\.])9([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Mountain Lion', group: 'mac', identifier: 'Mac OS X (10([_|\.])8([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Lion', group: 'mac', identifier: 'Mac OS X (10([_|\.])7([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Snow Leopard', group: 'mac', identifier: 'Mac OS X (10([_|\.])6([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Leopard', group: 'mac', identifier: 'Mac OS X (10([_|\.])5([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Tiger', group: 'mac', identifier: 'Mac OS X (10([_|\.])4([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Panther', group: 'mac', identifier: 'Mac OS X (10([_|\.])3([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Jaguar', group: 'mac', identifier: 'Mac OS X (10([_|\.])2([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Puma', group: 'mac', identifier: 'Mac OS X (10([_|\.])1([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS X Cheetah', group: 'mac', identifier: 'Mac OS X (10([_|\.])0([0-9_\.]*))', versionSeparator: '[_|\.]' },
  //     { name: 'Mac OS', group: 'mac', identifier: 'Mac OS' },
  //     { name: 'Ubuntu', group: 'linux_server', identifier: 'Ubuntu', versionIdentifier: 'Ubuntu/([0-9\.]*)' },
  //     { name: 'CentOs', group: 'linux_server', identifier: 'CentOs', versionIdentifier: 'CentOs/([0-9\.]*)' },
  //     { name: 'Debian', group: 'linux_server', identifier: 'Debian' },
  //     { name: 'Gentoo', group: 'linux_server', identifier: 'Gentoo' },
  //     { name: '国产系统', group: 'linux', identifier: 'Linux' }
  // ];
  
  // var setOsData = function (os) {
  //     var userAgent = navigator.userAgent.toLowerCase();
  //     // Check browser type
  //     for (i in osData) {
  //         if (osData.hasOwnProperty(i)) {
  //             var osRegExp = new RegExp(osData[i].identifier.toLowerCase());
  //             var osRegExpResult = osRegExp.exec(userAgent);
  
  //             if (osRegExpResult != null) {
  //                 os.name = osData[i].name;
  //                 os.group = osData[i].group;
  //                 break;
  //             }
  //         }
  //     }
  
  //     return true;
  // };
  
  // var setOsVersion = function (os, version, separator) {
  //     if (separator.substr(0, 1) == '[') {
  //         var splitVersion = version.split(new RegExp(separator, 'g'), 2);
  //     } else {
  //         var splitVersion = version.split(separator, 2);
  //     }
  
  //     if (separator != '.') {
  //         version = version.replace(new RegExp(separator, 'g'), '.');
  //     }
  
  //     os.fullVersion = version;
  
  //     // Major version
  //     if (splitVersion[0]) {
  //         os.majorVersion = parseInt(splitVersion[0]);
  //     }
  
  //     // Minor version
  //     if (splitVersion[1]) {
  //         os.minorVersion = parseInt(splitVersion[1]);
  //     }
  
  //     return true;
  // };
  
  function GUID() {
    this.date =
      new Date(); /* 判断是否初始化过，如果初始化过以下代码，则以下代码将不再执行，实际中只执行一次 */
    if (typeof this.newGUID != "function") {
      /* 生成GUID码 */
      GUID.prototype.newGUID = function () {
        this.date = new Date();
        var guidStr = "";
        sexadecimalDate = this.hexadecimal(this.getGUIDDate(), 16);
        sexadecimalTime = this.hexadecimal(this.getGUIDTime(), 16);
        for (var i = 0; i < 9; i++) {
          guidStr += Math.floor(Math.random() * 16).toString(16);
        }
        guidStr += sexadecimalDate;
        guidStr += sexadecimalTime;
        while (guidStr.length < 32) {
          guidStr += Math.floor(Math.random() * 16).toString(16);
        }
        return this.formatGUID(guidStr);
      };
      /* * 功能：获取当前日期的GUID格式，即8位数的日期：19700101 * 返回值：返回GUID日期格式的字条串 */
      GUID.prototype.getGUIDDate = function () {
        return (
          this.date.getFullYear() +
          this.addZero(this.date.getMonth() + 1) +
          this.addZero(this.date.getDay())
        );
      };
      /* * 功能：获取当前时间的GUID格式，即8位数的时间，包括毫秒，毫秒为2位数：12300933 * 返回值：返回GUID日期格式的字条串 */
      GUID.prototype.getGUIDTime = function () {
        return (
          this.addZero(this.date.getHours()) +
          this.addZero(this.date.getMinutes()) +
          this.addZero(this.date.getSeconds()) +
          this.addZero(parseInt(this.date.getMilliseconds() / 10))
        );
      };
      /* * 功能: 为一位数的正整数前面添加0，如果是可以转成非NaN数字的字符串也可以实现 * 参数: 参数表示准备再前面添加0的数字或可以转换成数字的字符串 * 返回值: 如果符合条件，返回添加0后的字条串类型，否则返回自身的字符串 */
      GUID.prototype.addZero = function (num) {
        if (Number(num).toString() != "NaN" && num >= 0 && num < 10) {
          return "0" + Math.floor(num);
        } else {
          return num.toString();
        }
      };
      /*  * 功能：将y进制的数值，转换为x进制的数值 * 参数：第1个参数表示欲转换的数值；第2个参数表示欲转换的进制；第3个参数可选，表示当前的进制数，如不写则为10 * 返回值：返回转换后的字符串 */ GUID.prototype.hexadecimal =
        function (num, x, y) {
          if (y != undefined) {
            return parseInt(num.toString(), y).toString(x);
          } else {
            return parseInt(num.toString()).toString(x);
          }
        };
      /* * 功能：格式化32位的字符串为GUID模式的字符串 * 参数：第1个参数表示32位的字符串 * 返回值：标准GUID格式的字符串 */
      GUID.prototype.formatGUID = function (guidStr) {
        var str1 = guidStr.slice(0, 8) + "-",
          str2 = guidStr.slice(8, 12) + "-",
          str3 = guidStr.slice(12, 16) + "-",
          str4 = guidStr.slice(16, 20) + "-",
          str5 = guidStr.slice(20);
        return str1 + str2 + str3 + str4 + str5;
      };
    }
  }
  
  //删除cookies
  if (!getCookie("device_uid")) {
    var guid = new GUID();
    setCookie("device_uid", guid.newGUID());
  }
  function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
  
  function http(params, cb) {
    var contentType = "application/x-www-form-urlencoded; charset=utf-8";
  
    var timestamp = Date.parse(new Date()) / 1000;
    var data = params.data || {};
    console.log(data);
    var type = "POST";
    var files = null;
    // var commonData = null
    var appKey = deobfuscateString(data.appKey).substring(20);
    var device_uid = "";
    // alert(getCookie('device_uid'))
    if (getCookie("device_uid")) {
      device_uid = getCookie("device_uid");
    } else {
      var guid = new GUID();
      setCookie("device_uid", guid.newGUID());
      device_uid = getCookie("device_uid");
    }
    var commonData = {
      event_time: timestamp,
      os: validataOS(),
      osVersion: sessionStorage.getItem("os_version") || "",
      deviceUID: device_uid,
      user_agent: navigator.userAgent,
      referer: document.referrer,
      browser: sessionStorage.getItem("ua") || "",
      url: location.href,
      browser_version: sessionStorage.getItem("ua_version") || "",
      // device_uid
      // browser
      // browser_version
      // user_agent
      // url
      // referer
    };
  
    if (data.headimg) {
      files = data.headimg;
      delete data.headimg;
    }
    if (data.commonData) {
      // commonData = data.commonData
      delete data.commonData;
    }
    // alert(appKey)
    if (appKey) {
      delete data.appKey;
    }
  
    if (getQueryParams().channelID) {
      data.sourceChannelID = getQueryParams().channelID;
    }
    if (getQueryParams().deviceUID) {
      data.deviceUID = getQueryParams().deviceUID;
    } else {
      data.deviceUID = device_uid;
    }
    data.timestamp = timestamp;
  
    var data = objKeySort(data);
    // data.openid = openid
    // data = objKeySort(data)
    str = "";
    for (var i in data) {
      str += data[i];
    }
  
    var sign = $.md5(decodeURI(str + appKey));
    data.signature = sign;
  
    if (files !== null) {
      data.headimg = files;
    }
    if (commonData !== null) {
      // data.commonData = JSON.stringify(commonData)
      data.commonData = JSON.stringify(commonData);
    }
  
    // new Fingerprint2().get(function(result, components) {
    $.ajax({
      url: params.url,
      type: type,
      contentType: contentType,
      // BrowserFinger:result,
      dataType: "json",
      // xhrFields: {
      //     withCredentials: true
      // },
      data: data,
      crossDomain: true,
      success: function (r) {
        if (r.code == 0 || r.code == 40106 ) {
          cb(r);
        } else if (r.code == 10108) {
          // cb(r)
          var cookie = cookieJS.cookie;
  
          cookie("username", null, { path: "/" });
          cookie("userkey", null, { path: "/" });
          cookie("useruid", null, { path: "/" });
          cookie("phone", null, { path: "/" });
          cookie("email", null, { path: "/" });
          cookie("findpwdcode", null, { path: "/" });
          cookie("aofeilastusername", null, { path: "/" });
  
          $("#c-logIn").show();
          $("#c-c-elb").hide();
          window.location.href =
            "https://" + window.location.host + "/passport/login.html";
          // window.location.reload();
        } else {
          alert(r.msg);
        }
  
        // $("#info").html(JSON.stringify(data)+"<br />"+JSON.stringify(r))
      },
      error: function (r) {
        alert(r.msg);
        console.log("请求错误....", r);
      },
    });
  
    // })
  }
  
  function http2(params, cb) {
    var timestamp = Date.parse(new Date()) / 1000;
    var data = params.data || {};
    var files = null;
    // var commonData = null
    var appKey = deobfuscateString(data.appKey).substring(20);
    var device_uid = "";
    // alert(getCookie('device_uid'))
    if (getCookie("device_uid")) {
      device_uid = getCookie("device_uid");
    } else {
      var guid = new GUID();
      setCookie("device_uid", guid.newGUID());
      device_uid = getCookie("device_uid");
    }
    data.deviceUID = device_uid;
    // var commonData={
    //     event_time:timestamp,
    //     os:validataOS(),
    //     os_version:os.name,
    //     device_uid:device_uid,
    //     user_agent:navigator.userAgent,
    //     referer:document.referrer,
    //     browser:'',
    //     url:location.href,
    //     browser_version:''
    //     // device_uid
    //     // browser
    //     // browser_version
    //     // user_agent
    //     // url
    //     // referer
    // }
    if (data.headimg) {
      files = data.headimg;
      delete data.headimg;
    }
    if (data.commonData) {
      // commonData = data.commonData
      delete data.commonData;
    }
  
    if (appKey) {
      delete data.appKey;
    }
    // function objKeySort(o) {
    //     let sorted = {},
    //     keys = Object.keys(o);
    //     keys.sort();
    //     keys.forEach((key)=>{
    //       sorted[key] = o[key];
    //     })
    //     return sorted;
    //   }
  
    data.timestamp = timestamp;
    var data = objKeySort(data);
    // data.openid = openid
    // data = objKeySort(data)
    str = "";
    for (var i in data) {
      str += data[i];
    }
  
    // $("#info").html(decodeURI(str+appKey))
    var sign = $.md5(decodeURI(str + appKey));
    data.signature = sign;
  
    if (files !== null) {
      data.headimg = files;
    }
    // if(commonData !==null){
    //     // data.commonData = JSON.stringify(commonData)
    //     data.commonData = JSON.stringify(commonData);
  
    // }
  
    // new Fingerprint2().get(function(result, components) {
    //     console.log(components)
    // $.ajax({
    //     url: params.url,
    //     type: type,
    //     contentType:contentType,
    //     // BrowserFinger:result,
    //     // dataType: 'json',
    //     // xhrFields: {
    //     //     withCredentials: true
    //     // },
    //     data: data,
    //     crossDomain: true,
    //      success:function (r) {
    //     //  console.log(r)
    //      $('#login-img').attr('src',"data:application/octet-stream,"+r)
    //     //  return(r)
    //         // cb(r)
    //         // $("#info").html(JSON.stringify(data)+"<br />"+JSON.stringify(r))
    //     },
    //     error:function(r) {
    //         console.log(r)
    //         console.log("请求错误....",r);
  
    //     }
    // })
    // alert(device_uid)
  
    // var demo=JSON.stringify(commonData2)
    // console.log(typeof(demo))
    // console.log('444')
    // alert(data.deviceUID)
    //"&deviceUID=" + '4fc0567d-9134-3c9c-10ac-be458bc4324a'+
    var imgUrl =
      params.url +
      "/?appID=" +
      data.appID +
      "&channelID=" +
      data.channelID +
      "&deviceUID=" +
      data.deviceUID +
      "&from=" +
      data.from +
      "&subChannelID=" +
      data.subChannelID +
      "&timestamp=" +
      data.timestamp +
      "&signature=" +
      data.signature;
    return imgUrl;
    // + "&commonData="+demo
  
    // })
  }
  function getQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    // 或者如果你传入了一个特定的URL，可以使用：
    // const urlParams = new URLSearchParams(new URL(url).search);
  
    // 获取特定的查询参数
    const paramValue = urlParams.get("paramName"); // 替换 'paramName' 为你需要的参数名
  
    // 获取所有查询参数作为一个对象
    const paramsObject = {};
    urlParams.forEach((value, key) => {
      paramsObject[key] = value;
    });
  
    return paramsObject; // 或者 return paramValue; 如果你只需要一个特定的参数
  }
  
  module.exports = {
    http: http,
    http2: http2,
    setCookie: setCookie,
    getCookie: getCookie,
    delCookie: delCookie,
    decryptByDES: decryptByDES,
  };
  

});
